// extracted by mini-css-extract-plugin
export default {"eligibility":"oA-z"};